import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import {
  showNotification,
  evaluateQantity,
  convertCalculation,
} from '@/services/calculate'
import { formatCurrency } from '@/services/convert'
import {
  addGridRecord,
  updateGridRecord,
  updateRowStyle,
  updateMultipleGridRecord,
  addMultipleGridRecord,
  deleteMultipleGridRecord,
} from '@/services/grid'
import { apiRequestArray, validateNumber } from '@/services/config'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import AutoCompleteRenders from '@/components/DynamicComponents/Renderers/autoCompleteRenders'
import CalculationEditor from '@/components/DynamicComponents/Renderers/calculationEditor'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Contract'
import CategoryCodeComponent from '@/components/DynamicComponents/Admin/MasterData/Project/CategoryCode'
import TakeoffComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Takeoff'
import EstimateGroupTakeoff from '@/components/DynamicComponents/Projects/NewConstruction/EstimateGroups/Grid/Grid'
import TreeTakeoffs from '@/components/DynamicComponents/Projects/TreeTakeoffs'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'estimate-group-takeoff': EstimateGroupTakeoff,
    'add-category-code': CategoryCodeComponent,
    'add-contract': ContractComponent,
    'add-takeoff': TakeoffComponent,
    'tree-takeoff': TreeTakeoffs,
  },
  props: [
    'takeoffs',
    'screenIndentifier',
    'dropdownData',
    'groupDetails',
    'type',
    'activeTab',
    'isArchive',
  ],
  data() {
    return {
      data: [],
      redrawTable: false,
      loading: false,
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: false,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        suppressContextMenu: true,
        stopEditingWhenGridLosesFocus: false,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: true,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          editable: true,
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      height: '16rem',
      selectedRowKeys: [],
      selectedRows: [],
      formatCurrency: formatCurrency,
      pinnedTopRowData: [],
      isAddContract: false,
      isAddCategory: false,
      isAddTakeoff: false,
      takeoffDetails: null,
      title: 'Add New Estimate',
      visibleTakeoff: false,
      visibleExpand: false,
      checkAll: false,
      domLayout: null,
      changeIndex: undefined,
      isCalculationError: false,
      isBlurCalled: true,
      postSort: null,
      keys: [
        'contract',
        'categoryCode',
        'additionalDescription',
        'takeoff',
        'calculation',
        'quantity',
        'unit',
        'unitCost',
        'multiplier',
      ],
      width: '110rem',
      padding: '0px',
      isAddFrom: false,
      isValidTakeoff: false,
      checked: false,
    }
  },
  beforeMount() {
    this.loadingConfig()
    window.addEventListener('resize', this.detectViewPortListener)
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  created() {
    this.domLayout = 'autoHeight'
    this.$root.$off('cloneTileTakeoff')
    this.$root.$off('deleteTileTakeoff')
    this.$root.$off('handleTileChange')
    this.$root.$off('updateAdjustmentTakeoff')
    if (this.groupDetails.id === this.activeTab) {
      this.$root.$off(`onCloneTakeoff${this.groupDetails.assetId}`)
      this.$root.$off(`onDeleteTakeoff${this.groupDetails.assetId}`)
      this.$root.$off(`onUpdateTakeoff${this.groupDetails.assetId}`)
      this.$root.$off(`bankTakeoffs${this.groupDetails.assetId}`)
      this.$root.$on(
        `onUpdateTakeoff${this.groupDetails.assetId}`,
        this.onUpdateTakeoff,
      )
      this.$root.$on(
        `onCloneTakeoff${this.groupDetails.assetId}`,
        this.cloneTakeoff,
      )
      this.$root.$on(
        `onDeleteTakeoff${this.groupDetails.assetId}`,
        this.deleteRecord,
      )
      this.$root.$on(
        `bankTakeoffs${this.groupDetails.assetId}`,
        this.getTakeoffs,
      )
    }
  },
  mounted() {
    this.loadingConfig()
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        customFilter: CustomFilter,
        selectEditor: SelectEditor,
        costPriceCellRenderer: CurrencyRenderer,
        inputNumberEditor: InputNumberEditor,
        toolTipRenderer: ToolTipRenderer,
        textEditor: TextEditor,
        autocomplete: AutoCompleteRenders,
        calculationEditor: CalculationEditor,
      }

      this.columnDefs = [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          hide: true,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellStyle: { textAlign: 'left' },
          width: 100,
          cellEditor: 'selectEditor',
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          resizable: true,
          cellRendererParams: {
            type: 'estimateGroup',
            dropdownName: 'contract',
            dropdownData: this.dropdownData,
          },
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'estimateGroup',
            dropdownName: 'category',
            dropdownData: this.dropdownData,
          },
          width: 150,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Cat Code',
          suppressSizeToFit: true,
          resizable: true,
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center', backColor: 'red' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'estimateGroup',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'autocomplete',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'estimateGroup',
            name: 'takeoff_Name',
            screen: 'Project',
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Takeoff',
          resizable: true,
          width: 420,
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'estimateGroup',
            name: 'calculation',
            dropdownData: this.dropdownData.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'estimateGroup',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Quantity',
          resizable: true,
          suppressSizeToFit: true,
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'estimateGroup',
            dropdownName: 'unit',
            dropdownData: this.dropdownData,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Unit',
          resizable: true,
          suppressSizeToFit: true,
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          cellRendererParams: {
            searchType: 'string',
            type: 'estimateGroup',
            placeholder: 'Unit Cost',
            precision: 2,
            min: 0,
          },
          width: 120,
          headerTooltip: 'Unit Cost',
          resizable: true,
          suppressSizeToFit: true,
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'estimateGroup',
            precision: 3,
            name: 'multiplier',
          },
          width: 100,
          resizable: true,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Total Cost',
          field: 'totalPrice',
          headerTooltip: 'Total Cost',
          cellRenderer: 'costPriceCellRenderer',
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          editable: false,
        },
        {
          headerName: 'Trended Cost',
          field: 'trendedCost',
          headerTooltip: 'Trended Cost',
          cellRenderer: 'costPriceCellRenderer',
          headerClass: 'header-right',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          editable: false,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'estimateGroup',
          },
          floatingFilter: false,
          width: 100,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
        },
      ]
    },

    handleOk() {},

    handleCancel() {
      this.visibleTakeoff = false
      this.addFrom = 'Grouping Bank'
      this.treeData = []
      this.selectedNodes = undefined
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
    },

    getData(params) {
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      this.takeoffs.forEach(element => {
        if (element.calculation) {
          element.formula = convertCalculation(
            element.calculation,
            this.propData,
            this.groupDetails.calculation,
            this.dropdownData.calculation,
          )
          if (evaluateQantity(element.formula) < 0) {
            element.quantity = element.quantity < 0 ? null : element.quantity
          }
        }
      })
      params.api.setRowData(this.takeoffs)
      this.isValidTakeoff = this.takeoffs.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (!this.isValidTakeoff && this.checked) {
        this.sortTakeoffs(this.isValidTakeoff)
      }
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) - 241 + 'px'
      }
    },

    refreshColumns() {
      const displayColumns = this.columnDefs
      displayColumns.map(col => {
        let align = ''
        if (col.cellStyle) {
          align = col.cellStyle.textAlign
        }
        if (col.field !== 'action') {
          col.cellStyle = param => updateRowStyle(param, col.field, align)
        }
        if (col.headerName !== 'Action' && col.headerName !== '') {
          col.filter = 'customFilter'
          col.menuTabs = this.checked ? [] : ['filterMenuTab']
          col.sortable = !this.checked
        }
        if (this.keys.includes(col.field)) {
          col.editable = !this.isArchive
        } else if (!col.field) {
          col.editable = false
        } else {
          col.editable = false
        }
        if (col.field === 'checkbox' || col.field === 'action') {
          col.hide = this.isArchive
        }
      })
      return displayColumns
    },

    addTakeoffFrom() {
      this.visibleTakeoff = true
    },

    addTakeoffs() {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.takeoff.add(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      instance
        .post(url)
        .then(response => {
          let newData = [...this.data]
          newData = newData.concat(_.get(response.data, 'result', []))
          this.data = [...newData]
          var itemsToAdd = addGridRecord(_.get(response.data, 'result', {}))
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          this.gridOptions.api.redrawRows()
          const result = _.get(response.data, 'result', [])
          const indexOfNewRecord = this.data.findIndex(
            val => val.id === result.id,
          )
          this.gridOptions.api.setFocusedCell(indexOfNewRecord, 'takeoff')
          this.gridOptions.api.startEditingCell({
            rowIndex: indexOfNewRecord,
            colKey: 'takeoff',
          })
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    onUpdateTakeoff(value, record, key, index, takeoffData, data, keyCode) {
      if (this.groupDetails && this.groupDetails.assetId === record.assetId) {
        this.changeIndex = index
        const findIndex = this.data.findIndex(val => val.id === record.id)

        if (findIndex > -1) {
          const newData = [...this.data]
          const currentValue =
            value === 0 ? value.toString() : !value ? '' : value
          const previousValue = !window.previousValue
            ? ''
            : window.previousValue
          if (
            (currentValue !== null &&
              previousValue.toString() !== currentValue.toString()) ||
            key === 'calculation'
          ) {
            const url = projectAPIs.project.asset.estimate.takeoff.update(
              this.$route.params.id,
              this.groupDetails.assetId,
              this.groupDetails.id,
            )
            let enabled = true
            let request
            let isValid = true
            const isPresent = this.selectedRowKeys.some(i => i === record.id)
            const ids = isPresent ? this.selectedRowKeys : [record.id]
            const details = {
              contract: data,
              categoryCode: data,
              record: record,
              list: newData,
              value: value,
              takeoff: takeoffData,
              unit: data,
              selectedKeys: ids,
              key: key,
            }
            switch (key) {
              case 'calculation':
                request = apiRequestArray(details, index)
                break
              case 'contract':
                this.takeoffDetails = { ...record }
                if (value === 'addContract') {
                  this.isAddContract = true
                  enabled = false
                } else {
                  request = apiRequestArray(details, index)
                }
                break
              case 'categoryCode':
                this.takeoffDetails = { ...record }
                if (value === 'addCategory') {
                  this.isAddCategory = true
                  enabled = false
                } else {
                  request = apiRequestArray(details, index)
                }
                break
              case 'takeoff':
                this.takeoffDetails = { ...record }
                window.previousValue = value
                this.isBlurCalled = false
                if (value === 'new') {
                  this.isAddTakeoff = true
                  enabled = false
                } else {
                  request = apiRequestArray(details, index)
                }
                break
              case 'quantity':
                this.takeoffDetails = { ...record }
                isValid = validateNumber(value, key, 'Quantity')
                if (isValid) {
                  request = apiRequestArray(details, index)
                }
                break
              case 'unitCost':
                this.takeoffDetails = { ...record }
                isValid = validateNumber(value, key, 'Unit Cost')
                if (isValid) {
                  request = apiRequestArray(details, index)
                }
                break
              case 'multiplier':
                this.takeoffDetails = { ...record }
                isValid = validateNumber(value || 0, key, 'Multiplier')
                if (isValid) {
                  request = apiRequestArray(details, index)
                }
                break
              default:
                this.takeoffDetails = { ...record }
                request = apiRequestArray(details, index)
                break
            }
            if (enabled && isValid) {
              const msg = 'Please wait...'
              this.$root.$emit('popupUpdation', true, true, msg)
              instance
                .patch(url, request)
                .then(response => {
                  this.updateTakeoff(
                    response.data,
                    record,
                    newData,
                    key,
                    keyCode,
                    ids,
                  )
                })
                .catch(err => {
                  this.resetRowData(index)
                  this.$root.$emit('popupUpdation', false, true, null)
                  errorService(err)
                })
            } else if (enabled) {
              this.isBlurCalled = true
              setTimeout(() => {
                this.resetRowData(index)
              }, 100)
            }
          } else {
            this.isBlurCalled = true
            if (findIndex === this.data.length - 1 && key === 'multiplier') {
              if (keyCode === 9) {
                this.addTakeoffs()
              }
            }
          }
        }
      }
    },

    updateTakeoff(data, record, newData, key, keyCode, ids) {
      newData = _.get(data.result, 'takeoffs', [])
      ids.forEach(element => {
        const index = this.data.findIndex(val => val.id === element)
        if (record.formula) {
          newData[index].formula = record.formula
        }
        if (key === 'calculation' && evaluateQantity(record.formula) < 0) {
          newData[index].quantity = null
        }
      })
      newData.forEach(element => {
        if (element.calculation) {
          element.formula = convertCalculation(
            element.calculation,
            this.propData,
            this.groupDetails.calculation,
            this.dropdownData.calculation,
          )
          if (evaluateQantity(element.formula) < 0) {
            element.quantity = element.quantity < 0 ? null : element.quantity
          }
        }
      })
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateMultipleGridRecord(this.gridOptions, newData)
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      if (record) {
        const rowIndex = this.data.findIndex(val => val.id === record.id)
        this.gridOptions.api.forEachNodeAfterFilter(node => {
          node.setSelected(false)
        })
        this.setActiveCell(key, rowIndex, keyCode)
      }
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
      if (!this.isValidTakeoff && this.checked) {
        this.sortTakeoffs(this.isValidTakeoff)
      }
      this.loading = false
      this.isBlurCalled = true
      this.takeoffDetails = null
      this.$emit('updateTakeoff', data.result)
    },

    setActiveCell(key, index, keyCode) {
      const focusedCell = this.gridOptions.api.getFocusedCell()
      let focusKey
      if (focusedCell) {
        switch (key) {
          case 'contract':
            focusKey = 'categoryCode'
            window.previousValue = ''
            break
          case 'categoryCode':
            focusKey = 'additionalDescription'
            window.previousValue = ''
            break
          case 'additionalDescription':
            focusKey = 'takeoff'
            window.previousValue = ''
            break
          case 'takeoff':
            focusKey = 'calculation'
            break
          case 'calculation':
            focusKey = 'quantity'
            window.previousValue = ''
            break
          case 'quantity':
            focusKey = 'unit'
            window.previousValue = ''
            break
          case 'unit':
            focusKey = 'unitCost'
            window.previousValue = ''
            break
          case 'unitCost':
            focusKey = 'multiplier'
            window.previousValue = ''
            break
          case 'multiplier':
            window.previousValue = ''
            if (index === this.data.length - 1) {
              if (keyCode === 9) {
                this.addTakeoffs()
              }
            }
            break
          default:
            break
        }
        if (key !== 'multiplier') {
          this.gridOptions.api.setFocusedCell(index, focusKey)
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: focusKey,
          })
        }
      }
    },

    resetRowData(index) {
      const newData = [...this.data]
      if (newData[index]) {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
      }
      newData[index].quantity = this.takeoffDetails.quantity
      newData[index] = this.takeoffDetails
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.takeoffDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.takeoffDetails = null
    },

    deleteAllRecord() {
      if (this.selectedRowKeys.length > 0) {
        var that = this
        this.$confirm({
          title: `Are you sure want to delete ${this.selectedRowKeys.length} records?`,
          content: h => (
            <div style="color:red">
              <p>This action will delete all information related these rows.</p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(null)
          },
        })
      } else {
        showNotification(
          'warning',
          'Takeoffs',
          'Please select at least one takeoff!',
        )
      }
    },

    deleteRecord(record) {
      if (this.groupDetails && this.groupDetails.assetId === record.assetId) {
        const that = this

        this.$confirm({
          title: `Are you sure want to delete takeoff ?`,
          content: h => (
            <div style="color:red">
              <p>
                This action will delete all information related this line item.
              </p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(record)
          },
        })
      }
    },

    confirmDelete(record) {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.takeoff.delete(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(url, { data: ids })
        .then(response => {
          ids.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          if (record) {
            this.gridOptions.api.applyTransaction({ remove: [record] })
          } else {
            this.gridOptions.api.applyTransaction({
              remove: this.selectedRows,
            })
          }
          this.selectedRowKeys = []
          this.selectedRows = []
          this.updateTakeoff(response.data, null, this.data, null, null, [])
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    cloneTakeoff(id) {
      const record = this.data.find(i => i.id === id)
      if (record && this.groupDetails.assetId === record.assetId) {
        this.clone(id)
      }
    },

    cloneTakeoffs() {
      if (this.selectedRowKeys.length > 0) {
        this.clone()
      } else {
        showNotification(
          'warning',
          'Takeoffs',
          'Please select at least one takeoff!',
        )
      }
    },

    clone(id) {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.takeoff.clone(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      const newData = [...this.data]
      const isPresent = id ? this.selectedRowKeys.some(i => i === id) : true
      const ids = isPresent ? this.selectedRowKeys : [id]
      instance
        .put(url, ids)
        .then(response => {
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          const itemsToAdd = addMultipleGridRecord(
            newData,
            _.get(response.data, 'result.takeoffs', []),
          )
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          this.updateTakeoff(response.data, null, newData, null, null, [])
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    gridSizeChanged(e) {
      const element = document.querySelector('#estimateGroupTable')
      if (element) {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    tabToNextCell(params) {
      const previousCell = params.previousCellPosition
      const nextCellPosition = params.nextCellPosition
      let result = null
      const isTab = true
      if (isTab && nextCellPosition) {
        result = {
          rowIndex: nextCellPosition.rowIndex,
          column: nextCellPosition.column,
          floating: previousCell.floating,
        }
        return result
      }
    },

    onCellValueChanged(event) {
      if (event.colDef.field === 'calculation') {
        if (event.value) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.calculation = event.oldValue
          if (event.oldValue) {
            this.takeoffDetails.formula = convertCalculation(
              event.oldValue,
              null,
              this.groupDetails.calculation,
              this.dropdownData.calculation,
            )
          }
          const calculation = convertCalculation(
            event.value,
            null,
            this.groupDetails.calculation,
            this.dropdownData.calculation,
          )
          event.data.formula = calculation
          const reg = /^[0-9. ()]+([-+*/()]+[ -+()]?[ 0-9.()]+)*$/
          if (!reg.test(calculation)) {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else if (evaluateQantity(event.data.formula) === 'Error') {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else {
            this.onUpdateTakeoff(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              event.colDef.cellRendererParams.dataType,
              null,
              null,
              event.keyCode,
            )
          }
        } else {
          event.data.formula = undefined
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            event.colDef.cellRendererParams.dataType,
            null,
            null,
            event.keyCode,
          )
        }
      } else if (event.colDef.field === 'takeoff' && this.isBlurCalled) {
        if (event.value.length > 200) {
          showNotification(
            'error',
            'Takeoff',
            'Takeoff should consist of 200 characters only!',
          )
        } else {
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            null,
            null,
            null,
          )
        }
      }
      this.isBlurCalled = true
    },

    addContract(data, flag) {
      this.isAddContract = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.contract,
          this.takeoffDetails,
          'contract',
          index,
          null,
          data,
          null,
        )
        this.$root.$emit('addContract', data)
      } else {
        this.resetRowData(index)
      }
    },

    addCategory(data, contracts, flag) {
      this.isAddCategory = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        const category = {
          id: data.id,
          masterId: data.masterId,
          option: `${data.categoryCode} - ${data.description}`,
          value: `${data.categoryCode} - ${data.description}`,
          description: data.description,
          contractDetailsId: data.mContractDetailsId,
        }
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.categoryCode,
          this.takeoffDetails,
          'categoryCode',
          index,
          null,
          category,
          null,
        )
        this.$root.$emit('addCategoryCode', category, contracts)
      } else {
        this.resetRowData(index)
      }
    },

    addTakeOff(action) {
      this.isAddTakeoff = false
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (action === 'cancel') {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
        newData[index].area = this.propData.firstRowValues.area
        this.data = [...newData]
        this.gridOptions.api.redrawRows()
        const itemsToUpdate = updateGridRecord(
          this.gridOptions,
          this.takeoffDetails,
          newData[index],
        )
        this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
        this.gridOptions.api.redrawRows()
        this.setActiveCell('additionalDescription', index, null)
      } else {
        this.gridOptions.api.redrawRows()
        this.setActiveCell('additionalDescription', index, null)
      }
      this.takeoffDetails = null
    },

    expandTakeoff() {
      this.visibleExpand = true
    },

    onCancel() {
      this.visibleExpand = false
    },

    onClose(type, data, response) {
      let newData = [...this.data]
      let itemsToAdd = []
      switch (type) {
        case 'add':
          newData = newData.concat(data)
          this.data = [...newData]
          itemsToAdd = addGridRecord(data)
          this.gridOptions.api.applyTransaction({
            add: itemsToAdd,
          })
          this.gridOptions.api.redrawRows()
          break
        case 'clone':
          this.gridOptions.api.applyTransaction({
            add: data,
          })
          this.updateTakeoff(response, null, newData, null, null, [])
          break
        case 'delete':
          data.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element.id)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          const itemsToDelete = deleteMultipleGridRecord(
            this.gridOptions,
            data,
          )
          this.gridOptions.api.applyTransaction({
            remove: itemsToDelete,
          })
          this.updateTakeoff(response, null, this.data, null, null, [])
          break
        case 'update':
          newData = data
          const itemsToUpdate = updateMultipleGridRecord(
            this.gridOptions,
            data,
          )
          this.gridOptions.api.applyTransaction({
            update: itemsToUpdate,
          })

          this.data = [...newData]
          this.gridOptions.api.redrawRows()
          this.isValidTakeoff = this.data.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (!this.isValidTakeoff && this.checked) {
            this.sortTakeoffs(this.isValidTakeoff)
          }
          this.$emit('updateTakeoff', response.result)
          break

        default:
          break
      }
    },

    closeTakeoff(flag) {
      this.visibleTakeoff = flag
    },

    getTakeoffs() {
      this.loading = false
      if (this.isAddFrom) {
        this.isAddFrom = false
        this.loading = true
        instance
          .get(
            projectAPIs.project.asset.estimate.details(
              this.$route.params.id,
              this.groupDetails.assetId,
              this.groupDetails.id,
            ),
          )
          .then(response => {
            const newData = [...this.data]
            const itemsToAdd = addMultipleGridRecord(
              newData,
              _.get(response.data, 'result.takeoffs', []),
            )
            this.gridOptions.api.applyTransaction({
              add: itemsToAdd,
            })
            this.updateTakeoff(response.data, null, newData, null, null, [])
            this.loading = false
            if (this.visibleExpand) {
              this.$root.$emit('reloadTakeoffs', response.data)
            } else {
              this.$root.$emit('stopLoader', false)
            }
            this.$emit(
              'updateTakeoff',
              _.get(response.data, 'result', []),
            )
          })
          .catch(error => {
            this.loading = false
            errorService(error)
          })
      } else {
        if (this.visibleExpand) {
          this.$root.$emit('stopLoading', false)
        }
      }
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.width = '110rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.width = '100%'
        this.padding = '10px !important'
      } else {
        this.width = '110rem'
        this.padding = '0px !important'
      }
    },

    addNewTakeoffs(flag) {
      this.isAddFrom = flag
    },

    sortTakeoffs(value) {
      let sort = 'asc'
      let key = 'sequence'
      this.checked = value
      this.gridOptions.columnApi.applyColumnState({
        defaultState: { sort: null },
      })
      this.gridOptions.api.setFilterModel(null)
      if (value) {
        sort = 'asc'
        key = 'isValidTakeoff'
      }
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: key,
            sort: sort,
          },
        ],
        defaultState: { sort: null },
      })
      const displayColumns = this.refreshColumns()
      this.gridOptions.api.setColumnDefs(displayColumns)
      this.gridOptions.api.sizeColumnsToFit()
    },

    filterChanged() {
      this.isValidTakeoff = this.data.some(
        i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
      )
    },
  },
}
